import React, { useCallback, useEffect, useState } from "react"
import { toast } from "react-toastify"
import moment from "moment"
import { FaFileAlt, FaFilePdf, FaDownload } from "react-icons/fa"
import { getUserReports } from "../../../requesters/Backend/UserRequester"
import { calculatorTypeLabel } from "../../../util"

const REPORTS_LIMIT = 5

const formatDate = value => (value && moment(value).isValid() ? moment(value).format("DD MMM YYYY") : "—")

function UserReports({ baseUrl, userId }) {
  const [reports, setReports] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const fetchReports = useCallback(() => {
    if (!userId) {
      setReports([])
      setIsLoading(false)
      return
    }
    setIsLoading(true)
    getUserReports(baseUrl, { id: userId, limit: REPORTS_LIMIT })
      .then(res => {
        setReports(res?.response || [])
        setIsLoading(false)
        return null
      })
      .catch(() => {
        setReports([])
        setIsLoading(false)
        toast.error("Could not load reports")
      })
  }, [baseUrl, userId])

  useEffect(() => {
    fetchReports()
  }, [fetchReports])

  return (
    <div className="card">
      <div className="card-header">
        <h5>
          <FaFileAlt />
          Reports
        </h5>
      </div>
      <div className="card-body quick-actions">
        {isLoading && <div className="text-muted">Loading…</div>}
        {!isLoading && reports.length === 0 && (
          <div className="text-muted">No completed surveys yet</div>
        )}
        {!isLoading && reports.map(report => (
          report.report_available ? (
            <a
              className="quick-action"
              href={report.download_url}
              key={report.id}
              rel="noopener noreferrer"
              target="_blank">
              <span className="quick-action-label">
                <FaFilePdf />
                {calculatorTypeLabel(report.calculator_type, report.report_version)}
              </span>
              <span className="quick-action-meta">
                {formatDate(report.submitted_at)}
                <FaDownload className="ml-2" />
              </span>
            </a>
          ) : (
            <div className="quick-action text-muted" key={report.id} title="No report available for this survey">
              <span className="quick-action-label">
                <FaFilePdf />
                {calculatorTypeLabel(report.calculator_type, report.report_version)}
              </span>
              <span className="quick-action-meta">{formatDate(report.submitted_at)}</span>
            </div>
          )
        ))}
      </div>
    </div>
  )
}

export default UserReports
